import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IAuthState = {
    isLoginInProcess: false,
    isLogoutInProcess: false,
    isLogoutManual: false,
    wasSsoAttempted: false,
    wasAutoLoginCompleted: false,
    afterCredentialsLoginHooks: [],
    beforeRegistrationHooks: []
};

export const reducer = produce((draftState, action: Types.TAuthAction): Types.IAuthState | void => {
    switch (action.type) {
        case actionTypes.SET_LOGIN_IN_PROCESS: {
            Object.assign(draftState, {
                isLoginInProcess: action.payload
            });

            break;
        }
        case actionTypes.SET_SSO_ATTEMPTED: {
            Object.assign(draftState, {
                wasSsoAttempted: true
            });

            break;
        }
        case actionTypes.SET_AUTO_LOGIN_COMPLETED: {
            Object.assign(draftState, {
                wasAutoLoginCompleted: true
            });

            break;
        }
        case actionTypes.SET_LOGOUT_IN_PROCESS: {
            Object.assign(draftState, {
                isLogoutInProcess: action.payload
            });

            break;
        }
        case actionTypes.SET_IS_LOGOUT_MANUAL: {
            Object.assign(draftState, {
                isLogoutManual: action.payload
            });

            break;
        }
        case actionTypes.ADD_AFTER_CREDENTIALS_LOGIN_HOOK: {
            const { afterCredentialsLoginHooks } = draftState;

            Object.assign(draftState, {
                afterCredentialsLoginHooks: afterCredentialsLoginHooks.concat([action.payload])
            });

            break;
        }

        case actionTypes.ADD_BEFORE_REGISTRATION_HOOK: {
            const { beforeRegistrationHooks } = draftState;

            Object.assign(draftState, {
                beforeRegistrationHooks: beforeRegistrationHooks.concat([action.payload])
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
